import MaterialTableComponent from './MaterialTableComponent';

export default MaterialTableComponent;
